import {getEcho, resetEcho} from "../services/notifications/echoClient";

function getToken() {
    const raw =
        localStorage.getItem("token") ||
        localStorage.getItem("access_token") ||
        localStorage.getItem("auth_token") ||
        "";

    const token = raw.startsWith("Bearer ") ? raw.slice(7) : raw;
    return token || null;
}

// Expose a helper so you can init/reinit from console anytime
window.__initEcho = () => {
    const token = getToken();
    if (!token) {
        console.warn("[Echo] token missing in localStorage");
        return null;
    }

    resetEcho();
    const echo = getEcho({token});
    console.log("[Echo] initialized", echo);
    return echo;
};

// Optional: auto-init if token exists
(() => {
    const token = getToken();
    if (!token) return;
    const echo = getEcho({token});
    console.log("[Echo] auto-init", echo);
})();
